import {
  COLORS,
  FONT_SIZES,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  IconName,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

const ICON_ASSET: Record<'success' | 'error', IconName> = {
  success: GenericIconName.CheckmarkBorder,
  error: GenericIconName.Warning,
};

const ICON_CIRCLE_COLOR = {
  success: COLORS['Alerts.Success.Secondary'],
  error: COLORS['Alerts.Info.Secondary'],
};

export const NewsletterSubscriptionStatus: React.FC<{
  type: 'success' | 'error';
  headline: string;
  subline: string;
  className?: string;
}> = ({type, headline, subline, className}) => {
  return (
    <Container className={className}>
      <IconCircle $color={ICON_CIRCLE_COLOR[type]}>
        <Icon asset={ICON_ASSET[type]} size="M" />
      </IconCircle>
      <TextContainer>
        <Headline>{headline}</Headline>
        <Subline>{subline}</Subline>
      </TextContainer>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
`;

const IconCircle = styled.div<{$color: string}>`
  padding: 8px;
  border-radius: 50%;
  background-color: ${props => props.$color};
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Headline = styled(Text)`
  font-size: ${FONT_SIZES.px16};
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  line-height: 1.25;

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px24};
    font-weight: ${FONT_WEIGHTS.heavy};
    line-height: 1.2;
  `)}
`;

const Subline = styled(Text)`
  font-size: ${FONT_SIZES.px14};
  font-weight: ${FONT_WEIGHTS.mediumBold};
  line-height: 1.4;
`;
